
































import { Component, Mixins, Prop, Watch, Inject } from 'vue-property-decorator';
import { DeferredMixin, LoaderMixin } from '@/pages/profile/mixins';
import { DropDown, Carousel, Errors } from '@/pages/profile/components';
import { SimpleCard } from '@/pages/profile/blocks';
import { cabinetService, smartService } from '@/services';
import { Programs, IBlock, AxiosInstance } from './types';
import { SINGLE_TYPES, EXTERNAL_TYPES, NO_PROGRAMS_MESSAGE } from './const';

@Component({
  components: {
    DropDown,
    Carousel,
    SimpleCard,
    Errors,
  },
})
export default class Block
  extends Mixins(DeferredMixin, LoaderMixin)
  implements IBlock {
  @Inject()
  readonly $api!: AxiosInstance;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly description!: string;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: String, default: '' })
  readonly method!: string;

  @Prop({ type: String, default: 'cabinet' })
  readonly service!: string;

  @Prop({ type: Boolean, default: false })
  readonly isOpened!: boolean;

  @Prop({ type: [Array, Object, String], default: null })
  readonly data!: any;

  @Prop({ type: String, default: 'default' })
  readonly type!: string;

  public programs: Programs = [];
  public loaded = false;
  public opened: boolean = this.isOpened;
  public errors: any = [];

  get height(): string {
    const { programs, loaded } = this;
    return loaded && !programs.length ? '90px' : '217px';
  }

  get isExternal(): boolean {
    return EXTERNAL_TYPES.includes(this.type);
  }

  @Watch('id', { immediate: true })
  onChangeChild(id: string): void {
    this.reset();
    if (id && this.opened) this.getData();
  }

  onToggle(show: boolean): void {
    this.opened = !this.opened;
    const { programs, loaded } = this;
    if (show && !programs.length && !loaded) this.getData();
  }

  async getData(): Promise<void> {
    this.setStatus('loading');
    const { $api, method, data, service, type } = this;
    try {
      const result =
        service === 'smart'
          ? await smartService($api)[method](data)
          : await cabinetService($api)[method](data);
      this.programs = SINGLE_TYPES.includes(type) ? result : result[type];
      if (!this.programs.length) this.errors.push(NO_PROGRAMS_MESSAGE);
      this.setStatus('success');
    } catch (error) {
      this.errors.push(error);
      this.setStatus('error');
    } finally {
      this.loaded = true;
    }
  }

  reset(): void {
    this.errors = [];
    this.programs = [];
    this.loaded = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/career-guidance/components/block/Block.vue